module.exports = __webpack_public_path__ + "static/media/lock_secure.55fee682.png";